import { useEffect, useState } from "react";
import TspApiService from "../api/tspApiService";
import useTspApiResource from "./useTspApiResource";

const NOTHING = () => Promise.resolve({ data: null });

// The "which journey, which city visit" picker shared by Book Distribution,
// Public Response, Daily Reports and the media upload dialog: only IN_PROGRESS
// journeys are offered (activity can only be recorded against one — see the
// backend's city-visits/repository.js#assertJourneyExecutable), and picking a
// journey loads its recorded city visits to choose from.
//
// `skipJourneys`: the journey is already decided (a fixed `initialJourneyId`), so
// the list of journeys to choose from is not requested at all — only that
// journey's visits are.
export default function useTspJourneyVisitPicker(initialJourneyId, { skipJourneys = false } = {}) {
  const [journeyId, setJourneyId] = useState(initialJourneyId || "");
  const [visitId, setVisitId] = useState("");

  const journeys = useTspApiResource(
    () => (skipJourneys ? NOTHING() : TspApiService.listJourneys({ status: "IN_PROGRESS", sort: "journey_name", order: "asc", limit: 100 })),
    [skipJourneys]
  );
  const visits = useTspApiResource(() => (journeyId ? TspApiService.listCityVisits({ journey_id: journeyId, limit: 100 }) : NOTHING()), [journeyId]);

  // Changing the journey invalidates whichever visit was picked for the old one.
  useEffect(() => {
    setVisitId("");
  }, [journeyId]);

  return { journeys, journeyId, setJourneyId, visits, visitId, setVisitId };
}
